export const BABIES_RECEIVED = "BABIES_RECEIVED";
export const BABY_CREATED = "BABY_CREATED";
export const BABY_UPDATED = "BABY_UPDATED";
export const BABY_DELETED = "BABY_DELETED";